// extracted by mini-css-extract-plugin
module.exports = {"howItWorks":"HowItWorks_howItWorks__f85ol","collectionContainer":"HowItWorks_collectionContainer__I1Hxr","card":"HowItWorks_card__jqFCW"};